/* Otervano eyewear V2. Isolated model templates; existing pages remain untouched. Preview-aware native integration; never adds cart items. */
(() => {
  'use strict';
  if (customElements.get('ov-eyewear-v2-controller')) return;
  const views = new Set(["ov-lab-alba-v2","ov-lab-ancla-v2","ov-lab-arrecife-v2","ov-lab-bocana-v2","ov-lab-boya-v2","ov-lab-brisa-v2","ov-lab-cala-v2","ov-lab-cantil-v2","ov-lab-cauce-v2","ov-lab-cielo-v2","ov-lab-claraboya-v2","ov-lab-costa-v2","ov-lab-dique-v2","ov-lab-duna-v2","ov-lab-estero-v2","ov-lab-ladera-v2","ov-lab-marisma-v2","ov-lab-meandro-v2","ov-lab-monte-v2","ov-lab-neblina-v2","ov-lab-orilla-v2","ov-lab-otero-v2","ov-lab-pico-v2","ov-lab-presa-v2","ov-lab-rada-v2","ov-lab-raudal-v2","ov-lab-repecho-v2","ov-lab-represa-v2","ov-lab-ribera-v2","ov-lab-roble-v2","ov-lab-roca-v2","ov-lab-rafaga-v2","ov-lab-salto-v2","ov-lab-senda-v2","ov-lab-soto-v2","ov-lab-talco-v2","ov-lab-talud-v2","ov-lab-umbral-v2","ov-lab-vadeo-v2","ov-lab-vereda-v2","ov-lab-vertiente-v2","ov-lab-vista-v2"]);
  function previewURL(raw, view, retainedPreview) {
    const url = new URL(raw, location.origin);
    if (url.origin !== location.origin || !views.has(view)) return raw;
    url.searchParams.set('view', view);
    const live = new URL(location.href);
    const preview = retainedPreview || live.searchParams.get('preview_theme_id');
    if (preview) url.searchParams.set('preview_theme_id', preview);
    return url.pathname + url.search + url.hash;
  }
  class LabController extends HTMLElement {
    connectedCallback() {
      this.abort = new AbortController();
      this.root = this.closest('.ov-eyewear-v2-page');
      this.view = this.dataset.view;
      if (!this.root || !views.has(this.view) || this.dataset.product !== this.dataset.expected) return;
      const signal = this.abort.signal;
      this.onChange = (event) => {
        const target = event.target;
        if (target instanceof Element && target.matches('input[name="id"]') && this.root.contains(target)) this.setTechnology(target.value);
      };
      this.onVariant = (event) => {
        const info = this.root.querySelector('product-info');
        if (event.detail?.sectionId === info?.dataset.section) this.setTechnology(event.detail.variant?.id);
      };
      document.addEventListener('change', this.onChange, {signal});
      document.addEventListener('variant:change', this.onVariant, {signal});
      document.addEventListener('product-info:loaded', () => this.bindNative(), {signal});
      document.addEventListener('shopify:section:load', () => this.bindNative(), {signal});
      customElements.whenDefined('product-info').then(() => {if (this.isConnected) this.bindNative();});
      this.bindNative();
      this.dataset.ready = "true";
    }
    disconnectedCallback() { this.abort?.abort(); this.restoreNative?.(); }
    setTechnology(id) {
      this.root?.querySelectorAll('[data-ovlab-tech]').forEach((element) => {
        if (!element.ovlabData) {
          try { element.ovlabData = JSON.parse(element.querySelector('[data-ovlab-tech-data]').textContent); }
          catch (_) { return; }
        }
        const data = element.ovlabData[String(id)];
        const title = element.querySelector('[data-ovlab-tech-title]');
        const text = element.querySelector('[data-ovlab-tech-text]');
        if (title) title.textContent = data?.title || 'Selecciona una opción disponible';
        if (text) text.textContent = data?.text || 'Confirma la combinación antes de agregarla al carrito.';
        element.dataset.variant = id ? String(id) : '';
      });
    }
    bindNative() {
      const info = this.root?.querySelector('product-info');
      if (!info || typeof info.renderProductInfo !== 'function' || info.ovlabBound) return;
      const view = this.view;
      const retainedPreview = new URL(location.href).searchParams.get('preview_theme_id');
      const renderOriginal = info.renderProductInfo;
      const urlOriginal = info.updateURL;
      const quantityOriginal = info.fetchQuantityRules;
      const controller = this;
      info.renderProductInfo = function(args) {
        return renderOriginal.call(this, {...args, requestUrl: previewURL(args.requestUrl, view, retainedPreview)});
      };
      info.updateURL = function(url, variantId) {
        urlOriginal.call(this, url, variantId);
        if (this.dataset.updateUrl !== 'false') history.replaceState(history.state, '', previewURL(location.href, view, retainedPreview));
      };
      // Native cart subscription was bound before this controller. Rebind only this Lab instance.
      info.fetchQuantityRules = function() {
        const id = this.productForm?.variantIdInput?.value;
        if (!id) return;
        const spinner = this.querySelector('.quantity__rules-cart .loading__spinner');
        spinner?.classList.remove('hidden');
        const url = new URL(this.dataset.url, location.origin);
        url.searchParams.set('variant', id);
        url.searchParams.set('section_id', this.dataset.section);
        return fetch(previewURL(url.href, view, retainedPreview))
          .then(response => {if (!response.ok) throw new Error('No se pudo actualizar la cantidad.'); return response.text();})
          .then(text => {if (this.isConnected && this.productForm?.variantIdInput?.value === id) this.updateQuantityRules(this.dataset.section, new DOMParser().parseFromString(text, 'text/html'));})
          .catch(error => console.warn('[OTERVANO LAB] Cantidad:', error.message))
          .finally(() => spinner?.classList.add('hidden'));
      };
      const rebind = () => {
        if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
        info.cartUpdateUnsubscriber?.();
        if (info.isConnected && info.quantityInput && info.quantityForm && !info.dataset.originalSection) info.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, info.fetchQuantityRules.bind(info));
      };
      rebind();
      info.ovlabBound = true;
      controller.restoreNative = () => {
        info.renderProductInfo = renderOriginal;
        info.updateURL = urlOriginal;
        info.fetchQuantityRules = quantityOriginal;
        rebind();
        delete info.ovlabBound;
      };
      const selected = info.querySelector('input[name="id"]')?.value;
      if (selected) this.setTechnology(selected);
    }
  }
  customElements.define('ov-eyewear-v2-controller', LabController);
})();

/* Rating placement is owned by ov-eyewear-reviews.js to avoid duplicate remount handlers. */
